
const mIsEnabled = new WeakMap();
const mSortSpecData = new WeakMap();
const mOnEnableFn = new WeakMap();

class SortSpecification {
    constructor(isEnabled, sortTargetName, onEnableFn) {
        mIsEnabled.set(this, isEnabled);
        mSortSpecData.set(this, {
            sortTarget: sortTargetName,
            sortReverse: null
        });

        mOnEnableFn.set(this, onEnableFn);
    }

    get isEnabled() {
        return mIsEnabled.get(this);
    }

    set isEnabled(updatedVal) {
        let shouldEnable = (updatedVal === true);
        mIsEnabled.set(this, shouldEnable);

        if (shouldEnable) {
            mOnEnableFn.get(this)(mSortSpecData.get(this).sortTarget);
        }
    }

    get spec() {
        return mSortSpecData.get(this);
    }
}

export default SortSpecification;



//////////////////
// WEBPACK FOOTER
// ./src/views/trackerbase-admin/SortSpecification.js
// module id = X55i
// module chunks = 1